/*
 * @Description: 上传文件表单类
 * @Author: 杨志航
 * @Date: 2026-01-23 09:11:02
 */
import { message } from 'antd'
import urls from '@/api/urls'

export const uploadDragger = props => {
  const { name, action, accept, limitSize = 5, limitNum = 1 } = props

  return {
    name: name || 'file',
    action: action || urls.fileUpload.url,
    accept: accept || '.rar, .zip, .doc, .docx, .pdf, .jpg, .jpeg, .png, .bmp, .gif, .pptx, .PDF, .csv, .xlsx',
    headers: {
      token: localStorage.getItem('token')
    },
    beforeUpload: file => {
      if (file.size / 1024 / 1024 > limitSize) {
        message.error(`单个文件大小不能超过${limitSize}M`)
        return false
      }
      return true
    },
    normFile: evt => {
      // console.log('Upload event:', evt)
      let { fileList } = evt
      // 过滤为满足beforeUpload的文件
      fileList = fileList.filter(item => item.status)
      // 限制文件数量
      fileList = fileList.slice(-limitNum)
      // 提取需要的文件列表
      fileList = fileList.map(item => {
        const { uid, status, response } = item
        if (response) {
          const { data: { full, name } } = response
          return {
            uid,
            status,
            url: full,
            name
          }
        } else {
          return item
        }
      })
      return fileList
    }
	}
}

// export class DraggerUpload {
//   constructor(props) {
//     const { name, action, accept, limitSize, limitNum } = props
//     this.name = name || 'file'
//     this.action = action || '/api/File/upload'
//     this.accept = accept || '.rar, .zip, .doc, .docx, .pdf, .jpg, .jpeg, .png, .bmp, .gif, .pptx, .PDF, .csv, .xlsx'
//     this.headers = {
//       token: localStorage.getItem('token')
//     }
//     this.limitSize = limitSize || 5
//     this.limitNum = limitNum || 1
//   }

//   beforeUpload = file => {
//     if (file.size / 1024 / 1024 > this.limitSize) {
//       message.error(`单个文件大小不能超过${this.limitSize}M`)
//       return false
//     }
//     return true
//   }

//   static normFile = evt => {
//     console.log('Upload event:', evt)
//     let { fileList } = evt
//     // 过滤为满足beforeUpload的文件
//     fileList = fileList.filter(item => item.status)
//     // 限制文件数量
//     console.log(333, this.limitNum)
//     fileList = fileList.slice(-this.limitNum)
//     // 提取需要的文件列表
//     fileList = fileList.map(item => {
//       const { uid, status, response } = item
//       if (response) {
//         const { data: { full, name } } = response
//         return {
//           uid,
//           status,
//           url: full,
//           name
//         }
//       } else {
//         return item
//       }
//     })
//     return fileList
//   }
// }